import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { viewCmsAction } from '../../actions';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

function CMSView({ viewCmsAction }) {
    const [categoryData, setCategoryData] = useState(null);
    const history = useHistory();
    const params = useParams();
    const id = params.id;

    useEffect(() => {
        viewCmsAction({ id: id }, (err, response) => {
            if (!err) {
                setCategoryData(response.data.data);
            }
        });
    }, [id, viewCmsAction]);

    return (
        <div className="col-lg-12">
            <div className="card">
                {
                    categoryData ?
                        <>
                            <div className="header d-flex justify-content-between align-items-center">
                                <h2>
                                    {categoryData.title}
                                </h2>
                            </div>
                            <div className="body table-responsive">
                                <table className="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th>Title:</th>
                                            <td>{categoryData.title}</td>

                                        </tr>
                                        <tr>
                                            <th>SEO Title:</th>
                                            <td>{categoryData.seoTitle}</td>

                                        </tr>
                                        <tr>
                                            <th> SEO Description:</th>
                                            <td>{categoryData.seoDescription}</td>
                                        </tr>
                                        <tr>
                                            <th>Keywords:</th>
                                            <td>{categoryData.keywords}</td>
                                        </tr>
                                        <tr>
                                            <th>Display Under Where we operate ?:</th>
                                            <td>{categoryData.belongsToWhereWeOperate ? 'Yes' : 'No'}</td>
                                        </tr>
                                        <tr>
                                            <th>Created At:</th>
                                            <td>{moment(categoryData.createdAt).format('YYYY-MM-DD hh:mm a')}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </> :
                        <div className="text-center">
                            <Loader
                                type="Bars"
                                color="#00BFFF"
                                height={100}
                                width={100}
                                timeout={3000} //3 secs
                            />
                        </div>

                }

            </div>
        </div>
    )
}

export default connect(null, { viewCmsAction })(CMSView)